import { orderBy } from 'lodash-es'

export const eventsGetItemsForMonth = (months: array = [], eventsData: array = []) => {
  return months?.map(month => {
    const eventItems = eventsData?.filter(entry => {
      const dateTimeRanges = entry?.attributes?.dateTimeRanges
      return dateTimeRanges.some((dateTimeRange: object) => {
        return dayJs(month).isBetween(dayJs(dateTimeRange?.dateTimeStart), dayJs(dateTimeRange?.dateTimeEnd)) ||
          dayJs(dateTimeRange?.dateTimeStart).isSame(month, 'month') ||
          dayJs(dateTimeRange?.dateTimeEnd).isSame(month, 'month')
      })
    })
    const eventItemsSorted = orderBy(eventItems, ['sortKeyAsc', 'sortKeyDesc', 'title'], ['desc', 'asc', 'asc'])

    const monthName = dayJs(month)?.format('MMMM')
    return {
      startOfMonth: month,
      monthName: monthName,
      eventItems: eventItemsSorted
    }
  })
}
